export const subscriptionApiErrorMessages = {
  currentBillingCycleStatusIsUnknown: 'Volgende besteldatum kan niet worden gewijzigd',
  rebillInProgress: 'Volgende besteldatum kan niet worden gewijzigd: herfacturering in uitvoering',
  paymentFailed: 'Volgende besteldatum kan niet worden gewijzigd: betaling mislukt'
};
